export const normalizeForUsername = (value = '') => (
  value
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-zA-Z0-9]/g, '')
    .toLowerCase()
)

export const buildSuggestedUsername = (name, lastName) => {
  const normalizedName = normalizeForUsername(name)
  const normalizedLastName = normalizeForUsername(lastName)
  if (!normalizedName || !normalizedLastName) return ''
  return `${normalizedName.charAt(0)}${normalizedLastName}`
}
